/**
 * Created by shobhitjain on 31/12/19.
 */

import React from 'react';
import TableRow from './TableRow';
import PropTypes from 'prop-types';

/**
 * TableRows component returns TR with multiple TDs
 * @param data
 * @param keys
 * @param isClickableRow
 * @param excludedObjectForStyle
 * @param associatedObject
 * @returns {*}
 * @constructor
 */
const TableRows = ({
  data,
  keys,
  isClickableRow,
  excludedObjectForStyle,
  associatedObject
}) => {
  return (
    <tbody>
      {data.length > 0 &&
        data.map((tableRow) => {
          return (
            <TableRow
              associatedObject={associatedObject}
              isClickableRow={isClickableRow}
              keys={keys}
              excludedObjectForStyle={excludedObjectForStyle}
              tableRowData={tableRow}
            />
          );
        })}
    </tbody>
  );
};
/**
 * Proptypes
 * @type {{data: shim, keys: shim, excludedObjectForStyle: shim, isClickableRow: shim, associatedObject: shim}}
 */
TableRows.propTypes = {
  data: PropTypes.array.isRequired,
  keys: PropTypes.array.isRequired,
  isClickableRow: PropTypes.bool,
  excludedObjectForStyle: PropTypes.object,
  associatedObject: PropTypes.object
};
/**
 * Default props
 * @type {{excludedObjectForStyle: {}, isClickableRow: boolean, associatedObject: {}}}
 */
TableRows.defaultProps = {
  isClickableRow: false,
  excludedObjectForStyle: {},
  associatedObject: {}
};

export default TableRows;
